import { render, staticRenderFns } from "./develop.vue?vue&type=template&id=7374f94f&scoped=true"
import script from "./develop.vue?vue&type=script&lang=js"
export * from "./develop.vue?vue&type=script&lang=js"
import style0 from "./develop.vue?vue&type=style&index=0&id=7374f94f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7374f94f",
  null
  
)

export default component.exports